export const getMaxScore = (isExponentialScale: boolean): number => {
  return isExponentialScale ? 16 : 4;
};

export const getScoreFromRating = (
  rating: number | null | undefined,
  isExponentialScale: boolean,
): number | null => {
  if (rating == null || rating === -1) return null;
  return isExponentialScale ? rating * rating : rating;
};

export const getThresholdScore = (starValue: number, isExponentialScale: boolean): number => {
  return isExponentialScale ? starValue * starValue : starValue;
};
